import { render, staticRenderFns } from "./cuccFluxMonitor.vue?vue&type=template&id=0f5c8ced&scoped=true&"
import script from "./cuccFluxMonitor.vue?vue&type=script&lang=js&"
export * from "./cuccFluxMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5c8ced",
  null
  
)

export default component.exports